import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'
import { getLanguageValue } from '../../../../../utils/getLanguageValue'

const BaseDataCheck = ({ baseData }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()
  useEffect(() => {
    if (!!baseData.foreignKey && !!baseData.number && !!getLanguageValue(baseData.internalName.values)) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [baseData])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'done' : 'must'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('articleAdmin:mainData')}</span>
    </>
  )
}

export default BaseDataCheck